<template>
  <v-container>
    <h1>{{ sectionName }}</h1>
    <br>
    <v-btn color="primary" @click="backRoute">Regresar</v-btn>
    <v-spacer></v-spacer>
    <br>
    <v-row>
      <v-col cols="12" md="4" sm="6" v-for="option in options" :key="option.name" class="pr-1">
        <v-btn max-height="74px" max-width="324px" min-height="110px" min-width="214px" 
          :class="setColorClass(option.color)" @click="openSelectedLibrary(option)">
          <div class="wrapSection">{{ option.label }}</div>
        </v-btn>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
h1 {
  font-size: xxx-large;
}

.btn-darkblue {
  display:block;width:100%;
  color: #FFFFFF !important;
  background-color: #005497 !important;
}

.btn-blue {
  display:block;width:100%;
  color: #FFFFFF !important;
  background-color: #0092d0 !important;
}

.btn-info {
  display:block;width:100%;
  color: #FFFFFF !important;
  background-color: #8d9296 !important;
}

.btn-warning {
  display:block;width:100%;
  color: #FFFFFF !important;
  background-color: #ef8728 !important;
}

.wrapSection {
  z-index: 5;
  text-transform: capitalize;
  height: auto;
  white-space: break-spaces !important;
  color: white;
  word-wrap: break-word !important;
  inline-size: 300px;
  overflow-wrap: break-word;
  font-size: 21px;
}
</style>
<script>
import axios from 'axios'

export default {
  data: () => ({
    sectionName: '',
    options: {},
    clases: [
      { id: "005497", color: "btn-darkblue" },
      { id: "0092d0", color: "btn-blue" },
      { id: "8d9296", color: "btn-info" },
      { id: "ef8728", color: "btn-warning" },
    ],
  }),
  computed: {

  },
  mounted() {
    this.getLibraries()
  },
  methods: {
    getLibraries() {
      axios.get(`/libraries/getLibraries/${this.$route.query.name}`)
        .then(response => {
          this.sectionName = this.$route.query.name
          this.options = response.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    redirect(url) {
      window.open(url, '_blank')
    },
    backRoute() {
      this.$router.push({ path: '/bibliotecas' })
    },
    setColorClass(color) {
      return this.clases.find(c => { return c.id === color }).color
    },
    openSelectedLibrary(option) {
      if(option.requiereAutenticacion){
        axios.get(`/libraries/auth/${option.nombre}`)
        .then(response => {
          this.redirect(`${option.url}?token=${encodeURIComponent(response.data)}`)
        })
        .catch(err => {
          console.error(err)
        })
      }else
        this.redirect(option.url)
    }
  },
}
</script>